import { Component, OnInit, HostListener, Inject } from '@angular/core';
import { DatePipe, DOCUMENT } from '@angular/common';
import navigation from '../../../data/navigation.json';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  constructor(@Inject(DOCUMENT) private document: Document, public translate: TranslateService) { }
  // Sticky Nav
  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event: Event) {
    //set up the div "id=nav
    if (document.body.scrollTop > 100 ||
      document.documentElement.scrollTop > 100) {
      document.getElementById('can-sticky').classList.add('sticky');
    }
    else {
      document.getElementById('can-sticky').classList.remove('sticky');
    }
  }
  public navigation = navigation;

  // Navigation
  navmethod: boolean = true;

  toggleNav() {
    this.navmethod = !this.navmethod;
  }

  public isMenuCollapsed = true;
  // Mobile
  open: boolean = false;
  trigger(item: { open: boolean; }){
    item.open = !item.open;
  }

  ngOnInit(): void {
    this.lang = sessionStorage.getItem('lang');
    if(this.lang == null){
      this.lang = 'mn';
    }
    console.log(this.lang);
  }

  lang: string;

  changeLang(lang: string){
    console.log(lang);
    this.translate.use(lang);
    sessionStorage.clear();
    sessionStorage.setItem('lang', lang);

    location.replace(window.location.href);
  }

  scrollTo() {
    document.getElementById('service').scrollIntoView({
      behavior: 'smooth'
    });
  }
}
